import React from "react";
//primereact
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
//components
import CreditCard from "./CreditCard";
import UserCards from "./UserCards";

const UserPaymentMethods = ({
  pix,
  card,
  cards,
  cardState,
  paymentMethod,
  setPaymentMethod,
  handleSelectCard,
  handleInputFocus,
  creditCardClient,
  handleInputChange,
  setActiveIndexModal,
  visiblePaymentMethods,
  setVisiblePaymentMethods,
  setVisibleModalCreditCard,
  handleSelectPaymentMethod,
}) => {
  const cardBrandIcon = {
    visa: "fa-brands fa-cc-visa",
    mastercard: "fa-brands fa-cc-mastercard",
    amex: "fa-brands fa-cc-amex",
    discover: "fa-brands fa-cc-discover",
    diners: "fa-brands fa-cc-diners-club",
    jcb: "fa-brands fa-cc-jcb",
    maestro: "fa-brands fa-cc-maestro",
    unknown: "fa-regular fa-credit-card",
  };

  const getCardBrand = (number) => {
    const cleanNumber = number.replace(/\s+/g, "");
    const cardPatterns = {
      visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
      mastercard: /^5[1-5][0-9]{14}$/,
      amex: /^3[47][0-9]{13}$/,
      discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      maestro: /^(?:5[06789]\d\d|6\d{3})\d{12,15}$/,
    };

    for (let brand in cardPatterns) {
      if (cardPatterns[brand].test(cleanNumber)) {
        return brand;
      }
    }

    return "unknown";
  };

  const maskCardNumber = (number) => {
    return number
      .split(" ")
      .map((group, index, arr) => {
        if (index === 0 || index === arr.length - 1) {
          return group; // Keep first and last group unchanged
        }
        return group.replace(/\d/g, "*"); // Mask other groups
      })
      .join(" ");
  };

  return (
    <>
      {visiblePaymentMethods &&
      (paymentMethod === null ||
        paymentMethod === "pix" ||
        (paymentMethod === "card" && cardState.card_number !== "")) ? (
        <>
          <UserCards cards={cards} handleSelectCard={handleSelectCard} />
          {card && (
            <div
              className={`card-payment-method ${
                paymentMethod === "card" && cardState.card_number !== ""
                  ? "card-payment-method-selected"
                  : ""
              } border rounded d-flex justify-content-start align-items-center p-3 my-2`}
              onClick={() => handleSelectPaymentMethod("card")}
            >
              <RadioButton
                name="card"
                value={"card"}
                onChange={(e) => handleSelectPaymentMethod(e.value)}
                checked={paymentMethod === "card"}
              />
              <i
                className={`${
                  cardState.card_number !== ""
                    ? cardBrandIcon[getCardBrand(cardState.card_number)]
                    : "fa-regular fa-credit-card"
                } mx-3`}
              ></i>
              <h5 className="mt-2">
                {cardState.card_number !== ""
                  ? maskCardNumber(cardState.card_number)
                  : "Adicionar Cartão"}
              </h5>
            </div>
          )}
          {pix && (
            <div
              className={`card-payment-method ${
                paymentMethod === "pix" ? "card-payment-method-selected" : ""
              } border rounded d-flex justify-content-start align-items-center p-3 my-2`}
              onClick={() => handleSelectPaymentMethod("pix")}
            >
              <RadioButton
                name="pix"
                value={"pix"}
                onChange={(e) => handleSelectPaymentMethod(e.value)}
                checked={paymentMethod === "pix"}
              />
              <i className="fa-brands fa-pix mx-3"></i>
              <h5 className="mt-2">Pix</h5>
            </div>
          )}
        </>
      ) : (
        <>
          {paymentMethod === "card" && (
            <>
              <div className="d-flex justify-content-end">
                <Button
                  outlined
                  type="button"
                  className="mb-3"
                  onClick={() => {
                    setVisiblePaymentMethods(true);
                    setPaymentMethod(
                      cardState.card_number !== "" ? "card" : null
                    );
                  }}
                  label="Voltar"
                  icon="fa-solid fa-arrow-left"
                />
              </div>
              <CreditCard
                noData
                state={cardState}
                handleInputChange={handleInputChange}
                handleInputFocus={handleInputFocus}
                onClickAddress={() => {
                  setVisibleModalCreditCard(true);
                  setActiveIndexModal(0);
                }}
                clientAddress={
                  creditCardClient?.address && creditCardClient?.address
                }
              />
              <div className="d-flex justify-content-end">
                <Button
                  type="button"
                  className="mb-3"
                  disabled={
                    !creditCardClient &&
                    !creditCardClient?.data &&
                    !creditCardClient?.address
                  }
                  onClick={() => {
                    setVisiblePaymentMethods(true);
                  }}
                  label="Salvar"
                  icon="fa-solid fa-check"
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default UserPaymentMethods;
